export default {"src":"/bnb/_next/static/media/safepalwallet.497b5c18.svg","height":20,"width":20};